module.exports = __webpack_public_path__ + "img/2_uk.4652e39b.svg";